<template>
  <Teleport to="body">
    <div
      v-if="isOpen"
      class="fixed inset-0 z-[99998] flex items-center justify-center bg-black/40 backdrop-blur-sm"
      @click.self="close"
    >
      <div
        class="bg-white dark:bg-n-solid-3 rounded-2xl shadow-2xl w-[480px] max-w-[90vw] max-h-[80vh] flex flex-col overflow-hidden ring-1 ring-black/5"
      >
        <div
          class="flex items-center gap-3 px-5 py-4 border-b border-n-weak bg-gradient-to-r from-amber-50 to-orange-50 dark:from-amber-950/20 dark:to-orange-950/20"
        >
          <span class="text-xl">📢</span>
          <h3 class="flex-1 text-base font-bold text-n-slate-12 m-0">
            Enviar Alerta
          </h3>
          <button
            class="size-8 rounded-lg flex items-center justify-center text-n-slate-11 hover:bg-n-alpha-2 transition-colors"
            @click="close"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            >
              <path d="M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5" />
            </svg>
          </button>
        </div>

        <div class="flex-1 overflow-y-auto px-5 py-4 flex flex-col gap-4">
          <div>
            <label class="text-xs font-semibold text-n-slate-11 mb-1.5 block"
              >Mensagem do alerta</label
            >
            <textarea
              v-model="message"
              class="w-full bg-n-alpha-black2 outline outline-1 outline-n-weak rounded-lg text-n-slate-12 px-3 py-2.5 text-sm resize-none leading-relaxed placeholder:text-n-slate-10 focus:outline-n-brand transition-all"
              placeholder="Digite a mensagem que será exibida para os agentes..."
              rows="3"
            />
          </div>

          <div class="flex gap-1 bg-n-alpha-black2 rounded-lg p-1">
            <button
              class="flex-1 text-xs font-semibold py-2 rounded-md transition-all"
              :class="
                tab === 'agents'
                  ? 'bg-white dark:bg-n-solid-3 text-n-slate-12 shadow-sm'
                  : 'text-n-slate-10 hover:text-n-slate-12'
              "
              @click="tab = 'agents'"
            >
              👤 Agentes
            </button>
            <button
              class="flex-1 text-xs font-semibold py-2 rounded-md transition-all"
              :class="
                tab === 'teams'
                  ? 'bg-white dark:bg-n-solid-3 text-n-slate-12 shadow-sm'
                  : 'text-n-slate-10 hover:text-n-slate-12'
              "
              @click="tab = 'teams'"
            >
              👥 Times
            </button>
          </div>

          <input
            v-model="searchQuery"
            class="w-full bg-n-alpha-black2 outline outline-1 outline-n-weak rounded-lg text-n-slate-12 px-3 py-2 text-sm placeholder:text-n-slate-10 focus:outline-n-brand transition-all"
            :placeholder="
              tab === 'agents' ? 'Buscar agente...' : 'Buscar time...'
            "
          />

          <div
            v-if="tab === 'agents'"
            class="flex flex-col gap-0.5 max-h-[200px] overflow-y-auto"
          >
            <label
              v-for="user in filteredAgents"
              :key="user.id"
              class="flex items-center gap-3 px-3 py-2.5 rounded-lg cursor-pointer hover:bg-n-alpha-1 transition-colors"
            >
              <input
                v-model="selectedUserIds"
                type="checkbox"
                :value="user.id"
                class="rounded accent-amber-500"
              />
              <div class="flex-shrink-0">
                <img
                  v-if="user.avatar_url"
                  :src="user.avatar_url"
                  class="size-8 rounded-full object-cover"
                />
                <div
                  v-else
                  class="size-8 rounded-full bg-n-brand text-white flex items-center justify-center font-semibold text-xs"
                >
                  {{ user.name?.charAt(0)?.toUpperCase() }}
                </div>
              </div>
              <div class="flex-1 min-w-0">
                <span
                  class="text-sm text-n-slate-12 font-medium truncate block"
                  >{{ user.name }}</span
                >
                <span class="text-xs text-n-slate-10 truncate block">{{
                  user.email
                }}</span>
              </div>
            </label>
            <p
              v-if="filteredAgents.length === 0"
              class="text-center text-n-slate-10 text-sm py-4"
            >
              Nenhum agente encontrado
            </p>
          </div>

          <div
            v-else
            class="flex flex-col gap-0.5 max-h-[200px] overflow-y-auto"
          >
            <label
              v-for="team in filteredTeams"
              :key="team.id"
              class="flex items-center gap-3 px-3 py-2.5 rounded-lg cursor-pointer hover:bg-n-alpha-1 transition-colors"
            >
              <input
                v-model="selectedTeamIds"
                type="checkbox"
                :value="team.id"
                class="rounded accent-amber-500"
              />
              <div
                class="size-8 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 text-white flex items-center justify-center text-xs font-bold"
              >
                {{ team.name?.charAt(0)?.toUpperCase() }}
              </div>
              <span class="text-sm text-n-slate-12 font-medium flex-1">{{
                team.name
              }}</span>
            </label>
            <p
              v-if="filteredTeams.length === 0"
              class="text-center text-n-slate-10 text-sm py-4"
            >
              Nenhum time encontrado
            </p>
          </div>
        </div>

        <div
          class="flex items-center justify-between px-5 py-3 border-t border-n-weak bg-n-alpha-1"
        >
          <span class="text-xs text-n-slate-10">
            {{ selectedCount }} selecionado{{ selectedCount !== 1 ? 's' : '' }}
          </span>
          <div class="flex gap-2">
            <button
              class="px-4 py-2 text-sm font-medium text-n-slate-11 hover:text-n-slate-12 rounded-lg hover:bg-n-alpha-2 transition-colors"
              @click="close"
            >
              Cancelar
            </button>
            <button
              class="px-4 py-2 text-sm font-bold text-white bg-gradient-to-r from-amber-500 to-orange-500 rounded-lg hover:from-amber-600 hover:to-orange-600 transition-all disabled:opacity-50 disabled:cursor-not-allowed shadow-sm"
              :disabled="!canSend || isSending"
              @click="send"
            >
              {{ isSending ? 'Enviando...' : '📢 Enviar Alerta' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useAlert } from 'dashboard/composables';
import InternalChatAPI from 'dashboard/api/internalChat';

const props = defineProps({
  isOpen: { type: Boolean, default: false },
});

const emit = defineEmits(['close']);

const store = useStore();
const message = ref('');
const tab = ref('agents');
const searchQuery = ref('');
const selectedUserIds = ref([]);
const selectedTeamIds = ref([]);
const isSending = ref(false);

const agents = computed(
  () => store.getters['internalChat/getAvailableUsers'] || []
);
const teams = computed(() => store.getters['teams/getTeams'] || []);

const filteredAgents = computed(() => {
  const q = searchQuery.value.toLowerCase();
  return agents.value.filter(
    u =>
      !q ||
      u.name?.toLowerCase().includes(q) ||
      u.email?.toLowerCase().includes(q)
  );
});

const filteredTeams = computed(() => {
  const q = searchQuery.value.toLowerCase();
  return teams.value.filter(
    t => !q || t.name?.toLowerCase().includes(q)
  );
});

const selectedCount = computed(
  () => selectedUserIds.value.length + selectedTeamIds.value.length
);

const canSend = computed(
  () => message.value.trim().length > 0 && selectedCount.value > 0
);

async function send() {
  if (!canSend.value) return;
  isSending.value = true;
  try {
    await InternalChatAPI.broadcastAlert({
      message: message.value.trim(),
      userIds: selectedUserIds.value,
      teamIds: selectedTeamIds.value,
    });
    message.value = '';
    selectedUserIds.value = [];
    selectedTeamIds.value = [];
    useAlert('Alerta enviado com sucesso!');
    close();
  } catch (e) {
    const errorMsg = e.response?.data?.error || 'Erro ao enviar alerta.';
    useAlert(errorMsg);
  } finally {
    isSending.value = false;
  }
}

function close() {
  emit('close');
}

onMounted(() => {
  store.dispatch('internalChat/fetchAvailableUsers');
  store.dispatch('teams/get');
});
</script>
